import {
  ClientConfigurationDataType,
  ConfigurationDataType,
} from 'src/clientConfiguration';
import { ConsentType } from './types';

export const DEFAULT_CONFIGURATION_DATA: ClientConfigurationDataType = {
  customData: [],
  configuration: {
    realTimeUpdate: false,
    consentType: ConsentType.NotRequired,
    dataApiDomain: 'data.kameleoon.io',
  },
};

export const DEFAULT_CLIENT_CONFIGURATION: ConfigurationDataType = {
  customData: [],
  featureFlags: [],
  configuration: {
    realTimeUpdate: false,
    consentType: ConsentType.NotRequired,
    dataApiDomain: 'data.kameleoon.io',
  },
};
